<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->

<div class="logo-container">
    <img height="64" src="../../../assets/cisco.png" alt="Cisco Logo">
</div>

<div class="integration-wrapper" *ngIf="integrationId">
    <form [formGroup]="formGroup">
        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{fAPI}}</mat-label>
                <input autocomplete="new-password" matInput id="api_key" type="password" formControlName="api_key" placeholder="{{fAPIPHolder}}">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{fID}}</mat-label>
                <input autocomplete="off" matInput name="client_id" id="client_id" type="search" formControlName="client_id" placeholder="{{fIDPHolder}}" maxlength="36">
            </mat-form-field>
            <!-- <mat-form-field class="field-input" appearance="outline">
                <mat-label>Client Secret</mat-label>
                <input matInput name="client_secret" id="client_secret" type="password" formControlName="client_secret">
            </mat-form-field> -->
        </div>
        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{fEndpoint}}</mat-label>
                <input matInput id="api_host" type="text" formControlName="api_host" placeholder="{{fEndpointPHolder}}">
            </mat-form-field>
        </div>

        <div class="section">
            <mat-radio-group [formControl]="formGroup.controls.lock_option" aria-label="Select what happens when a threat is received.">
                <div>
                    <mat-radio-button value="device_only">{{fLockA}}</mat-radio-button>
                </div>
                <div>
                    <mat-radio-button value="device_sets">{{fLockB}}</mat-radio-button>
                </div>
                <div>
                    <mat-radio-button value="all_devices">{{fLockC}}</mat-radio-button>
                </div>
            </mat-radio-group>
        </div>

        <div class="section">
            <mat-checkbox [formControl]="formGroup.controls.admin_unlock" matTooltip="Coming Soon">{{fAdmin}}</mat-checkbox>
        </div>

        <button type="button" (click)="cancel()" mat-raised-button>{{fCancel}}</button>
        <button type="button" color="primary" (click)="save()" [disabled]="!formGroup.valid" mat-raised-button>{{fSave}}</button>

    </form>
</div>
